import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface MetaAlertsInfoBoxProps {
  alerts: {
    main:
      | {
          code: number;
          status: string;
          description: string;
        }
      | undefined;
    partial:
      | {
          code: number;
          status: string;
          description: string;
        }
      | undefined;
  };
}

function MetaAlertsInfoBox({ alerts }: MetaAlertsInfoBoxProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  if (
    (!alerts.main?.status || alerts.main?.status === 'success') &&
    (!alerts.partial?.status || alerts.partial?.status === 'success')
  ) {
    return null;
  }

  return (
    <Box
      sx={{
        background: 'white',
        borderRadius: '10px',
        padding: '26px 24px',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        px: '44px',
        mx: '23px',
        my: 4,
        flex: 1,
        border: `1px solid ${theme.palette.warning.main}`,
      }}
    >
      <Typography
        fontSize="14px"
        color={theme.palette.warning.main}
        fontWeight={700}
        mb={2}
      >
        {t('mediaPlanning.errors.metaAlert')}
      </Typography>
      <Typography
        fontSize="14px"
        color={theme.palette.warning.main}
        fontWeight={400}
      >
        MetaErrors:
      </Typography>
      {alerts.main?.description && (
        <Typography
          fontSize="14px"
          color={theme.palette.warning.main}
          fontWeight={400}
        >
          RF Main: Code {alerts.main.code} {alerts.main?.description}
        </Typography>
      )}
      {alerts.partial?.description &&
        alerts.partial?.description !== alerts.main?.description && (
          <Typography
            fontSize="14px"
            color={theme.palette.warning.main}
            fontWeight={400}
          >
            RF 1P: Code {alerts.partial.code} {alerts.partial?.description}
          </Typography>
        )}
    </Box>
  );
}

export default MetaAlertsInfoBox;
